import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { CompraService } from 'src/app/components/compra/compra.service';
import { ProductoService } from 'src/app/components/producto/producto.service';
import { ProveedorCreateComponent } from 'src/app/components/proveedor/proveedor-create/proveedor-create.component';
import { ProveedorService } from 'src/app/components/proveedor/proveedor.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';

@Component({
  selector: 'app-compra-create-shared',
  templateUrl: './compra-create-shared.component.html',
  styles: [
  ]
})
export class CompraCreateSharedComponent implements OnInit {


  productos: any[] = [];
  proveedores: any[] = [];

  @Input() desdeCaja: boolean = false;

  clearEmitter: EventEmitter<string> = new EventEmitter();

  constructor(
    private loading: LoadingService,
    private alerts: AlertService,
    private productoService: ProductoService,
    private proveedoresService: ProveedorService,
    private service: CompraService,
    private router: Router,
    public formatter: FormatterService,
    private modalService: NgbModal
  ) { 
    this.loadProductos();
    this.cargarProveedores();
  }

  ngOnInit(): void {
  }

  addProveedor = () => {
    const modalRef = this.modalService.open(ProveedorCreateComponent,{ size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.cargarProveedores();
    }, (reason: any) => {});
  }

  clearVenta(): void {
    this.clearEmitter.emit();
  }

  cancelar(): void {
    this.clearEmitter.emit();
    if (this.desdeCaja) return;
    this.router.navigate(['compra/index']);
  }

  cargarProveedores(){
    this.loading.show()
    this.proveedoresService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.proveedores = res;
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  loadProductos(): void {
    this.loading.show();
    this.productoService.selectVenta().subscribe({
      next: (res: any[]) => {
        if (res.length === 0) {
          this.loading.hide();
          this.alerts.addAlert("No hay productos registrados.", "info");
        } else {
          this.loading.hide();
          this.productos = res.map(producto => {
            producto.precio_unitario = producto.precio_compra;
            return producto;
          });
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar la lista de productos.", "danger");
      }
    });
  }

  registrar(data: any): void {
    if (data.lineas.length === 0) {
      this.alerts.addAlert("Debe agregar al menos un producto a la compra.", "warning");
      return;
    }

    /*let total_pago: number = 0;
    let seleccion_credito: boolean = false;
    for (let i = 0; i < data.pagos.length; i++) {
      total_pago += data.pagos[i].monto;
      if (data.pagos[i].tipo == 6) {
        seleccion_credito = true;
      }
    }

    if (total_pago !== data.total) {
      this.alerts.addAlert("El monto pagado debe ser igual al total de la venta.", "warning");
      return;
    }*/

    const compra: any = data

    compra.monto = compra.neto

    compra.lineas = data.lineas.map((linea: { producto_id: number, cantidad: number, descuento: number, producto: { precio_unitario: number } }) => ({
      producto_id: linea.producto_id,
      cantidad: linea.cantidad,
      precio_unitario: linea.producto.precio_unitario,
      precio_linea: linea.cantidad * linea.producto.precio_unitario,
      descuento: linea.descuento,
    }));

    this.loading.show();
    this.service.create(compra).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.alerts.addAlert("Registro de compra generado con éxito.", "success");
        this.cancelar();
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el Registro de Compra.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      },
    });
  }
}
